import { IS_PROD } from 'modules/common/constants/env';

// in credits
const PRODUCTION_THRESHOLD = 10_000_000;
const STAGING_THRESHOLD = 30_000;

export const getPremiumActivationThreshold = () =>
  IS_PROD ? PRODUCTION_THRESHOLD : STAGING_THRESHOLD;
